import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@quintoandar-tokko/jopijs';
import PendingCard from '../../DashboardPendings/PendingsCard';
import RadioSelector from './components/RadioSelector';
import CurrencyDropdown from './components/CurrencyDropdown';
import CurrencyValuesInformation from './components/CurrencyValuesInformation';
import { getOverviewOperationStatistics } from '@/store/slices/components/dashboard/service';
import { getHeaderUrl } from './utils';
import useFetchDashboard from '../../customHooks/useFetchDashboard';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import styles from './totalValueCard.module.scss';
import DashboardEmptyStateCard from '../../DashboardEmptyStateCard';
import PropertyIcon from '@/public/images/dashboard/property.svg';
import { useTrackOverviewTab } from '../../customHooks/useTrackDashboard';

export default function TotalValueCard() {
  const dispatch = useDispatch();
  const { overviewOperationStatistics, miniCards } = useSelector(
    (state) => state.DashboardSlice
  );
  const { selectedIds } = useSelector((state) => state.FilterBarSlice.filters);
  const track = useTrackOverviewTab();
  const { ref, isStale, useFetchOnViewport } = useFetchDashboard();
  const tokkoBrokerHost = localStorage.getItem('tokkoBrokerHost');

  const { loading, hasFetched, selectedCurrency } = overviewOperationStatistics;
  const { selectedStatusId: statusId, propertiesValue } = miniCards;

  useFetchOnViewport(
    (query) => {
      dispatch(getOverviewOperationStatistics({ query, statusId }));
    },
    [statusId],
    { hasFetched }
  );

  const headerUrl = getHeaderUrl(
    overviewOperationStatistics,
    statusId,
    selectedIds
  );

  return (
    <PendingCard
      ref={ref}
      loading={loading || isStale}
      id="overview-properties"
    >
      <PendingCard.Header
        redirectUrl={propertiesValue === 0 ? null : headerUrl}
        toolTipText={Trans(translations, 'ShowAll')}
        trackCallback={(element) => track.propertyTotalValue(element)}
      >
        {Trans(translations, 'TotalValueCurrency', selectedCurrency)}
      </PendingCard.Header>

      {propertiesValue === 0 ? (
        <DashboardEmptyStateCard
          icon={PropertyIcon}
          title={Trans(
            translations,
            'HereYouWillSeeTheTotalValueOfYourProperties'
          )}
          buttonText={Trans(translations, 'CreateAProperty')}
          onButtonClick={() =>
            window.open(`${tokkoBrokerHost}/property/add/`, '_blank')
          }
        />
      ) : (
        <>
          <Box className={styles.header}>
            <RadioSelector />
            <CurrencyDropdown />
          </Box>
          <CurrencyValuesInformation />
        </>
      )}
    </PendingCard>
  );
}
